import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { RktFormComponent, formRadioGroup, formRow } from '@rocketfinancialcorp/rocket-ui/form';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

import { FinancialAccountDetails } from '@shared/models';

@Component({
  selector: 'app-financial-account-verification',
  imports: [RktIconComponent, FormsModule, ReactiveFormsModule, RktFormComponent, RktButtonDirective],
  templateUrl: './financial-account-verification.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './financial-account-verification.component.scss',
})
export class FinancialAccountVerificationComponent {
  verificationForm = new FormGroup({});

  formFields: FormlyFieldConfig[] = [
    formRow([
      formRadioGroup({
        key: 'accountVerificationType',
        label: '',
        className: 'single-row-radio-group',
        props: {
          options: [],
          required: true,
        },
      }),
    ]),
  ];

  formModel = {
    accountVerificationType: undefined,
  };

  constructor(public activeModal: ActiveModal) {}

  modalInitData(financialAccount: FinancialAccountDetails): void {
    const { subtype } = financialAccount;

    if (
      this.formFields[0] &&
      this.formFields[0]?.fieldGroup &&
      this.formFields[0]?.fieldGroup[0]?.props &&
      this.formFields[0]?.fieldGroup[0]?.props?.options
    ) {
      this.formFields[0].fieldGroup[0].props.options =
        subtype === 'CHECKING'
          ? [
              { label: 'Aggregation with Flinks', value: 'AGGREGATION' },
              { value: 'ACH', label: 'ACH' },
            ]
          : [{ label: 'Aggregation with Flinks', value: 'AGGREGATION' }];
    }
  }

  onSubmit() {
    const { accountVerificationType } = this.formModel;
    this.activeModal.close(accountVerificationType);
  }
}
